import { StockMarket } from "react-ts-tradingview-widgets";

const TvActiveStocks = () => (
  <StockMarket colorTheme="dark" isTransparent={true}  width={"100%"}></StockMarket>
);


export default TvActiveStocks
